import { ENDPOINT } from 'api/endPoints/getProductivityRiskTrend';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import {
    IHashmapItemWithCustomProps,
    IScoreCardsWrapperProps,
} from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { MEDIUM, SMALL } from 'components/Dashboards/Reporting/reportingConfig';

export const productivityRiskTrend: IHashmapItemWithCustomProps<IScoreCardsWrapperProps> = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            small: SMALL,
            medium: MEDIUM,
        },
        widgetInitialSize: SMALL,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: false,
        },
        hideNarrativeEditor: false,
    },
    title: 'Productivity Risk Trend',
    id: 'productivity-risk-trend',
    componentKey: 'productivityRiskTrend',
    endpoint: ENDPOINT,
};
